import { render, staticRenderFns } from "./AgentWithdrawal.vue?vue&type=template&id=4caa8f8a&scoped=true"
import script from "./AgentWithdrawal.vue?vue&type=script&lang=js"
export * from "./AgentWithdrawal.vue?vue&type=script&lang=js"
import style0 from "./AgentWithdrawal.vue?vue&type=style&index=0&id=4caa8f8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4caa8f8a",
  null
  
)

export default component.exports